export class NetzbetreiberKontaktinfos {
    public telefonAnsprechpartnerRedispatch?: string;
    public emailAnsprechpartnerRedispatch?: string;

    public telefonAnsprechpartnerKaskade?: string;
    public emailAnsprechpartnerKaskade?: string;

    public telefonAnsprechpartnerNfs?: string;
    public emailAnsprechpartnerNfs?: string;

    public emailKommunikation1?: string;
    public emailKommunikation2?: string;
    public emailKommunikation3?: string;
    public emailKommunikation4?: string;
}




